import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Pagination from '@material-ui/lab/Pagination';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';

import EPubModel from "../models/EPubModel";

import EnhancedTableToolbar from "./EnhancedTableToolbar";
import EnhancedTableHead from "./EnhancedTableHead";

import { inject, observer } from 'mobx-react';
import { shapes, Framework } from '@flint/framework';



const descendingComparator = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

const getComparator = (order, orderBy) => {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        padding: theme.spacing(4),
    },
    paper: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableHeading: {
        fontSize: "20px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        fontWeight: "bold",
        lineHeight: "29px",
        color: "#000000",
    },
    tableRow: {
        fontSize: "17px",
        fontFamily: "Nunito Sans",
        fontStyle: "normal",
        lineHeight: "30px",
        color: "#000000",
    },
    paginationRow: {
        padding: theme.spacing(2),
        display: "flex",
        justifyContent: "center",
    },
    colOrange:{
        color:"#DD7153",
    }
}));

const EPubTable = ({ EPubStore, EPubDeleteResStore, EPubDeleteResStoreStatus, EPubSyncAllResStore, EPubSyncAllResStoreStatus, EPubSyncResStore, EPubSyncResStoreStatus }) => {
    const classes = useStyles();
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('title');
    const [selected, setSelected] = React.useState([]);
    const [featured, setFeatured] = React.useState(false);
    const [page, setPage] = React.useState(0);
    const [rows, setRows] = React.useState([]);
    const [id, setId] = React.useState('');

    const rowsPerPage = 10;


    const [filter, setFilter] = React.useState('All');
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleSearchFilter = (event) => {
        setFilter(event.target.value);
    }

    const handleSearchEPub = (event) => {
        setSearchTerm(event.target.value);
    }

    const handleSyncEPub = (event) => {
        selected.forEach(select => {
            Framework.sendEvent("SYNC_EPUB_DATA", select);
        })
        setSyncDialogOpen(true);
    }
    const handleSyncAllEPub = (event) => {
        Framework.sendEvent("SYNC_ALL_EPUB_DATA");
        setSyncAllDialogOpen(true);
    }

    React.useEffect(() => {
        document.title = "Vet Admin Dashboard";
        EPubStore.fetch();
        setRows(EPubStore.epubs);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSearchSubmit = (event) => {
        event.preventDefault();
        let filteredRow = [];
        if (filter === "All") {
            for (let row of EPubStore.epubs) {
                let strRow = `${row.isbn} ${row.title} ${row.author} ${row.publisher}`;
                if (strRow.toLowerCase().includes(searchTerm.toLowerCase())) {
                    filteredRow.push(row);
                }
            }

        }
        else if (filter === "isbn") {
            for (let row of EPubStore.epubs) {
                if (row.isbn.includes(searchTerm.toLowerCase())) {
                    filteredRow.push(row);
                }
            }
        }
        else if (filter === "title") {
            for (let row of EPubStore.epubs) {
                if (row.title.toLowerCase().includes(searchTerm.toLowerCase())) {
                    filteredRow.push(row);
                }
            }
        }
        else if (filter === "author") {
            for (let row of EPubStore.epubs) {
                if (row.author.toLowerCase().includes(searchTerm.toLowerCase())) {
                    filteredRow.push(row);
                }
            }
        }
        else if (filter === "publisher") {
            for (let row of EPubStore.epubs) {
                if (row.publisher.toLowerCase().includes(searchTerm.toLowerCase())) {
                    filteredRow.push(row);
                }
            }
        }
        setRows(filteredRow);
    }

    const clearSearchFilter = () => {
        setFilter("All");
        setSearchTerm("");
        setRows(EPubStore.epubs);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleDeleteEPub = (event) => {
        selected.forEach(select => {
            Framework.sendEvent("DELETING_EPUB_DATA", select);
        })
        EPubStore.fetch();
        setRows(EPubStore.epubs);
        setSelected([]);
        setDeleteDialogOpen(true);
        EPubDeleteResStore.reset();
    }

    const handleReUploadEPub = (event) => {
        selected.forEach(select => {
            Framework.sendEvent("DELETING_EPUB_DATA", select);
        })
        setSelected([]);
        EPubStore.fetch();
        setRows(EPubStore.epubs);
        Framework.redirect(`/add-epub`);
    }

    const handleFeatureEpub = () => {
        selected.forEach(select => {
            Framework.sendEvent("FEATURING_EPUB_BOOK", {"isbn": select,"isDisplay": !featured});
        })
        setSelected([]);
        setTimeout(() => {
            EPubStore.fetch();
            setRows(EPubStore.epubs);
        }, 200);
    }

    const handleViewTopics = () => {
        Framework.redirect(`/topics/${id}`);
        Framework.sendEvent("FETCHING_TOPIC_LIST", id);
    }

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = rows.map((n) => n.isbn);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleRowClick = (event, row) => {
        setFeatured(row.isDisplay);
        setId(row.id);
        const selectedIndex = selected.indexOf(row.isbn);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, row.isbn);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage - 1);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;


    const [deleteDialogOpen, setDeleteDialogOpen] = React.useState(false);
    const [syncDialogOpen, setSyncDialogOpen] = React.useState(false);
    const [syncAllDialogOpen, setSyncAllDialogOpen] = React.useState(false);

    const handleDeleteDialogClose = () => {
        EPubStore.fetch();
        setRows(EPubStore.epubs);
        setSelected([]);
        setDeleteDialogOpen(false);
    };

    const handleSyncDialogClose = () => {
        setSelected([]);
        setSyncDialogOpen(false);
    };

    const handleSyncAllDialogClose = () => {
        setSelected([]);
        setSyncAllDialogOpen(false);
    };

    return (
        <>
            {EPubSyncResStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={syncDialogOpen}
                onClose={handleSyncDialogClose}
                aria-labelledby="sync-dialog-title"
                aria-describedby="sync-dialog-description"
            >
                <DialogTitle id="sync-dialog-title">ePub Cloud Sync</DialogTitle>
                <DialogContent>
                    <DialogContentText id="sync-dialog-description">
                        {EPubSyncResStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSyncDialogClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>}
            {EPubSyncAllResStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={syncAllDialogOpen}
                onClose={handleSyncAllDialogClose}
                aria-labelledby="sync-all-dialog-title"
                aria-describedby="sync-all-dialog-description"
            >
                <DialogTitle id="sync-all-dialog-title">ePub Cloud Sync All</DialogTitle>
                <DialogContent>
                    <DialogContentText id="sync-all-dialog-description">
                        {EPubSyncAllResStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleSyncAllDialogClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>}
            {EPubDeleteResStoreStatus.isPending ? <LinearProgress color="secondary" /> : <Dialog
                open={deleteDialogOpen}
                onClose={handleDeleteDialogClose}
                aria-labelledby="delete-dialog-title"
                aria-describedby="delete-dialog-description"
            >
                <DialogTitle id="delete-dialog-title">ePub Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="delete-dialog-description">
                        {EPubDeleteResStore.res}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDeleteDialogClose} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>}
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <EnhancedTableToolbar numSelected={selected.length} filter={filter} searchTerm={searchTerm} handleSearchFilter={handleSearchFilter} handleSearchEPub={handleSearchEPub} handleSearchSubmit={handleSearchSubmit} handleDeleteEPub={handleDeleteEPub} handleSyncEPub={handleSyncEPub} clearSearchFilter={clearSearchFilter} handleReUploadEPub={handleReUploadEPub} handleSyncAllEPub={handleSyncAllEPub} handleFeatureEpub={handleFeatureEpub} featured={featured} handleViewTopics={handleViewTopics} />
                    <TableContainer>
                        <Table
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'medium'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                            <TableBody>
                                {stableSort(rows, getComparator(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {
                                        const isItemSelected = isSelected(row.isbn);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <TableRow
                                                hover
                                                onClick={(event) => handleRowClick(event, row)}
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.isbn}
                                                selected={isItemSelected}
                                                className={classes.tableRow}
                                            >
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={isItemSelected}
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </TableCell>
                                                <TableCell component="th" id={labelId} scope="row" padding="none" className={classes.tableRow}>
                                                    {row.isbn}
                                                </TableCell>
                                                <TableCell align="left" className={classes.tableRow}>{row.title}</TableCell>
                                                <TableCell align="left" className={classes.tableRow}>{row.author}</TableCell>
                                                <TableCell align="left" className={classes.tableRow}>{row.publisher}</TableCell>
                                                <TableCell align="center" className={`${classes.tableRow} ${row.isDisplay?classes.colOrange:null}`}>{row.isDisplay?"Yes":"No"}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Pagination count={Math.ceil(rows.length / rowsPerPage)} onChange={handleChangePage} shape="rounded" className={classes.paginationRow} />
                </Paper>
            </div>
        </>
    );
}


EPubTable.propTypes = {
    EPubStore: shapes.modelOf(EPubModel),
};

export default inject('EPubStore', "EPubDeleteResStore", "EPubDeleteResStoreStatus", "EPubSyncAllResStore", "EPubSyncResStore", "EPubSyncResStoreStatus", "EPubSyncAllResStoreStatus")(observer(EPubTable));